export default __webpack_public_path__ + "static/media/270.de66c92e.jpg";